<mat-form-field
    subscriptSizing="dynamic"
    class="st-date-time-picker-date"
    [matTooltip]="label()">
    <mat-label
        *ngIf="label()"
        class="st-date-time-picker-label">
        {{ label() }}
    </mat-label>
    <input
        matInput
        [mtxDatetimepicker]="dateTimePicker"
        [required]="required()"
        [readonly]="disabled()"
        [placeholder]="placeholder()"
        [min]="minDate()"
        [formControl]="internalFormControl"
        (dateChange)="dateTimeChanged($event.value)" />
    <mtx-datetimepicker
        #dateTimePicker
        [type]="type"
        [mode]="mode"
        [twelvehour]="twelvehour"
        [timeInterval]="timeInterval"
        [calendarHeaderComponent]="dateTimePickerCustomHeaderComponent"
        [panelClass]="'st-date-time-picker-calendar'"
        [touchUi]="touchUi"
        [timeInput]="timeInput">
        <mtx-datetimepicker-actions class="st-date-time-picker-actions">
            <button
                mat-button
                mtxDatetimepickerClear>
                {{ clearLabel() }}
            </button>
            <button
                mat-button
                mtxDatetimepickerCancel>
                {{ cancelLabel() }}
            </button>
            <button
                class="st-date-time-picker-actions__apply-button"
                mat-button
                mtxDatetimepickerApply>
                {{ applyLabel() }}
            </button>
        </mtx-datetimepicker-actions>
    </mtx-datetimepicker>
    <mtx-datetimepicker-toggle
        class="st-time-control-toggle"
        matSuffix
        [for]="dateTimePicker"
        [disabled]="disabled()" />
    <ng-container
        *ngIf="hasSuffix()"
        matSuffix>
        <ng-content select="[suffix]" />
    </ng-container>
    <ng-container
        *ngIf="hasPrefix()"
        matPrefix>
        <ng-content select="[prefix]" />
    </ng-container>
    <ng-container
        *ngIf="hasError()"
        matError>
        <ng-content select="[error]" />
    </ng-container>
</mat-form-field>
